var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex flex-column flex-column-fluid",attrs:{"id":"kt_content"}},[_c('div',{staticClass:"container-fluid",staticStyle:{"padding":"0px 15px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }